export default utmSource => utmSource === 'chatbot';
